'use strict';

var BidPriceGraphController = function BidPriceGraphController(scope, dataRetrieverService, searchCriteriaFilterBuilderService, visibilityManager) {
  scope.cogOptions = require('../config/cogOptions.json');
  var dataRetriever = dataRetrieverService.getDataRetriever(scope.screen, scope.mode);
  scope.removeData = function () {
    scope.data = undefined;
  };
  scope.$on('search-criteria:searchChangeEvent', function () {
    scope.removeData();
  });
  scope.$on('brush-filter:filterApplied', function (event, brushFilter) {
    if (brushFilter.filterType === 'flightLevel' && visibilityManager.isBidPriceGraphVisible()) {
      retrieveData();
    }
  });
  function updateData(data) {
    if (data && data.length) {
      scope.data = data;
      scope.renderChart();
      scope.$emit('reload-carousel');
    }
  }
  function retrieveData() {
    if (visibilityManager.isBidPriceGraphVisible()) {
      var rules = searchCriteriaFilterBuilderService.buildFilter();
      dataRetriever.setCustomSearchCriteriaRules(rules).localSortApplied().retrieveComponentData('bid-price-graph').then(updateData);
    }
  }
  scope.retrieveData = retrieveData;
};
BidPriceGraphController.$inject = ['$scope', 'DataRetrieverService', 'FlightSearchCriteriaFilterBuilderService', 'FlightComponentVisibilityManagerService'];
module.exports = BidPriceGraphController;